import React from "react";
import {Checkbox, CheckboxProps, FormControlLabel, Grid, GridTypeMap, Tooltip, Typography} from "@mui/material";
import {InfoOutlined as InfoIcon} from "@mui/icons-material";

export interface CheckboxFieldProps extends Omit<CheckboxProps, "children" | "checked" | "onChange"> {
    label: string;
    checked: boolean;
    onChange: (target: EventTarget, checked: boolean) => void;
    isGridItem?: boolean;
    gridProps?: GridTypeMap["props"];
    infoIconTooltipText?: string;
}

export default function CheckboxField({
    name,
    label,
    onChange,
    isGridItem,
    gridProps,
    infoIconTooltipText,
    ...rest
}: CheckboxFieldProps) {
    const handleChange = (event: React.SyntheticEvent<Element, Event>, checked: boolean) => {
        onChange(event.target, checked);
    };

    const renderField = () => (
        <FormControlLabel
            control={<Checkbox name={name} {...rest} />}
            label={
                <Typography variant={"body2"}>
                    {label}
                    {infoIconTooltipText && (
                        <Tooltip title={infoIconTooltipText}>
                            <InfoIcon fontSize="small" />
                        </Tooltip>
                    )}
                </Typography>
            }
            id={name}
            name={name}
            onChange={handleChange}
        />
    );

    return isGridItem ? (
        <Grid item {...gridProps}>
            {renderField()}
        </Grid>
    ) : (
        renderField()
    );
}
